import { ApiProperty, ApiPropertyOptional } from '@nestjs/swagger';
import { IsOptional, IsArray, IsUUID } from 'class-validator';
import { Expose } from 'class-transformer';
import { JobRepairBuilderSupervisorBatchInterface } from '../interfaces/job-repair-builder-supervisor-batch.interface';

export class JobRepairBuilderSupervisorBatchDto
  implements JobRepairBuilderSupervisorBatchInterface
{
  @ApiPropertyOptional({
    type: () => String,
    title: 'Job Repair Builder Supervisor',
    nullable: true,
    isArray: true,
    description: 'Insert bulk',
  })
  @Expose()
  @IsOptional()
  @IsArray()
  @IsUUID('4', { each: true })
  insert!: string[];

  @ApiProperty({
    type: () => String,
    nullable: true,
    isArray: true,
    title: 'Job Repair Builder Supervisor IDs',
    description: 'Delete Bulk',
  })
  @Expose()
  @IsOptional()
  @IsArray()
  @IsUUID('4', { each: true })
  delete!: string[];
}
